var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-visual-video",
    class: {
      ready: _vm.isReady
    }
  }, [_c('div', {
    attrs: {
      "id": "player"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }